import { render } from "./Header.vue?vue&type=template&id=68bd988a&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=68bd988a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-68bd988a"

export default script